import React, { FC } from 'react'
import Image from 'next/image'
import styled from 'styled-components'
import { Box } from '@chakra-ui/react'
import { GalleryMainBadge } from 'src/uikit'

const StyledOverlay = styled.span`
  position:relative;
  display:inline-block;
  width: 100%;
  height: 100%;
  &:after {
    content:'';
    position:absolute;
    left:0; top:0;
    width:100%; height:100%;
    display:inline-block;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 70%,rgba(0, 0, 0, 0.5) 100%); /* W3C */
  }
`

const MainImage: FC<ImageGlobal.Image> = ({ src, alt, badge }) => (
  <Box borderRadius={10} pos="relative" overflow="hidden" bg="baseWhite" w="full" h="35rem" cursor="pointer">
    <StyledOverlay>
      <Image src={src} layout="fill" alt={alt} objectFit="contain" />
    </StyledOverlay>
    {badge && badge.length > 0 &&
      <GalleryMainBadge>{badge}</GalleryMainBadge>
    }
  </Box>
)

export default MainImage
